import type { DialogState, PatientInterviewState } from '../types';

export interface FsmInitializedPayload {
  fsmState?: DialogState | null;
}

export interface PatientStatePayload {
  patientState?: PatientInterviewState | null;
}

export interface InterviewStateMessageDependencies {
  setFsmState: (state: DialogState) => void;
  setPatientState: (state: PatientInterviewState) => void;
  attemptSttResume: () => void;
  debugLog: (...args: unknown[]) => void;
}

/** FSMと患者トラッカーの初期化・更新メッセージを画面状態へ反映する。 */
export class InterviewStateMessageController {
  constructor(private readonly dependencies: InterviewStateMessageDependencies) {}

  handleFsmInitialized(payload: FsmInitializedPayload = {}): void {
    const { fsmState } = payload;
    if (!fsmState) return;

    this.dependencies.debugLog(
      '[Client] fsm_initialized received, naCategories:',
      fsmState.naCategories,
    );
    this.dependencies.setFsmState(fsmState);
  }

  handlePatientTrackerInitialized(payload: PatientStatePayload = {}): void {
    const { patientState } = payload;
    if (patientState) {
      this.dependencies.debugLog(
        '[Client] patient_tracker_initialized received, phase:',
        patientState.phase,
        'naCategories:',
        patientState.naCategories,
      );
      this.dependencies.setPatientState(patientState);
    }

    // patientStateが空でもconnect_sessionの確定応答としてSTT再開を試みる。
    this.dependencies.attemptSttResume();
  }

  handlePatientStateUpdate(payload: PatientStatePayload = {}): void {
    const { patientState } = payload;
    if (!patientState) return;

    this.dependencies.debugLog(
      '[Client] patient_state_update received, phase:',
      patientState.phase,
    );
    this.dependencies.setPatientState(patientState);
  }
}
